import { render, staticRenderFns } from "./DeviceChannels.vue?vue&type=template&id=0af00eda&scoped=true"
import script from "./DeviceChannels.vue?vue&type=script&lang=js"
export * from "./DeviceChannels.vue?vue&type=script&lang=js"
import style0 from "./DeviceChannels.vue?vue&type=style&index=0&id=0af00eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af00eda",
  null
  
)

export default component.exports